import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DashboardMetric, getAdminDashboard } from "../../apis/dashboardApis";

interface DashboardState {
  data: DashboardMetric[];
  loading: boolean;
  error: string | null;
  fetched: boolean;
}

const initialState: DashboardState = {
  data: [],
  loading: false,
  error: null,
  fetched: false,
};

export const fetchDashboard = createAsyncThunk(
  "dashboard/fetchDashboard",
  async (
    params: { startDate: string; endDate: string },
    { rejectWithValue },
  ) => {
    try {
      const res = await getAdminDashboard(params);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Dashboard fetch failed",
      );
    }
  },
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    resetDashboard: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.fetched = true;
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;
